// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundWatchlist_background_wrapper__E1lAg","wrapper":"BackgroundWatchlist_wrapper__GjKRo"};